import { useEffect, useState } from 'react'
import { getPriceByCountry, DEFAULT_PRICE, PriceInfo } from '../utils/pricing'

interface GeoState {
  price: PriceInfo
  loading: boolean
  country: string | null
}

export function useGeoPrice(): GeoState {
  const [state, setState] = useState<GeoState>({
    price: DEFAULT_PRICE,
    loading: true,
    country: null,
  })

  useEffect(() => {
    let cancelled = false

    const detect = async () => {
      try {
        // ipapi.co — free, no API key, returns country_code
        const res = await fetch('https://ipapi.co/json/', {
          signal: AbortSignal.timeout(4000),
        })
        if (!res.ok) throw new Error('geo fetch failed')
        const data = await res.json()
        const code: string = data.country_code ?? ''
        if (!cancelled) {
          setState({
            price: getPriceByCountry(code),
            loading: false,
            country: code,
          })
        }
      } catch {
        // Fallback to USD on any error
        if (!cancelled) {
          setState({ price: DEFAULT_PRICE, loading: false, country: null })
        }
      }
    }

    detect()
    return () => {
      cancelled = true
    }
  }, [])

  return state
}
